// src/frontend/src/lib/diagrams.ts
//
// Technical schematics extracted from the vendor catalogues
// (Adeo Screen Catalogue June 2025, technical pages), served by the
// backend at /diagrams/<brand>/<variant-table-key>.png (static mount —
// see app/main.py; the frontend nginx SPA fallback cannot serve
// image-baked nested PNGs on the dev node).
//
// The mapping is keyed by variant_tables.key (migration 025) so every
// product linked to a table with a diagram gets its schematics section
// automatically. Adding a new family = drop the PNG in
// public/diagrams/<brand>/ and add its key here. Later this scales to
// all brands/products (owner directive 2026-10-25).

const KNOWN_DIAGRAMS = new Set([
  "inceel-tensio-classic-50",
  "rugby-pro-tensio-classic-50",
  "basic-no-borders",
  "prestige",
]);

/** Static diagram URL for a variant table, or null when none exists. */
export function diagramForVariantTable(tableKey: string | null | undefined):
    string | null {
  if (!tableKey || !KNOWN_DIAGRAMS.has(tableKey)) return null;
  return `/diagrams/adeo/${tableKey}.png`;
}
